import { Icon } from "PFComponents/icon";
import colors from "PFTheme/tokens/colors";
import React, { JSX } from "react";

type DownloadButtonProps = {
  downloadUri: string;
};

export const DownloadButton = ({ downloadUri }: DownloadButtonProps): JSX.Element => (
  <Icon name="export" size="sm" type="a" target="_blank" href={downloadUri} fill={colors.paletteBlue0} />
);
